import * as React from "react";
function SvgIcOrganisations(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 20.583V4h13.519v16.583H5zm8.26-.75h4.509V4.75H5.75v15.083h4.51v-1.58h3v1.58z"
        fill="currentColor"
      />
      <path
        d="M7.125 11.031h.75v1.318h-.75V11.03zM9.258 11.031h.75v1.318h-.75V11.03zM11.383 11.031h.75v1.318h-.75V11.03zM13.516 11.031h.75v1.318h-.75V11.03zM15.64 11.031h.75v1.318h-.75V11.03zM7.125 8.281h.75V9.6h-.75V8.28zM9.258 8.281h.75V9.6h-.75V8.28zM11.383 8.281h.75V9.6h-.75V8.28zM13.516 8.281h.75V9.6h-.75V8.28zM15.64 8.281h.75V9.6h-.75V8.28zM7.125 16.281h.75V17.6h-.75V16.28zM9.258 16.281h.75V17.6h-.75V16.28zM11.383 16.281h.75V17.6h-.75V16.28zM13.516 16.281h.75V17.6h-.75V16.28zM15.64 16.281h.75V17.6h-.75V16.28zM7.125 13.531h.75v1.319h-.75V13.53zM9.258 13.531h.75v1.319h-.75V13.53zM11.383 13.531h.75v1.319h-.75V13.53zM13.516 13.531h.75v1.319h-.75V13.53zM15.64 13.531h.75v1.319h-.75V13.53zM7.125 5.531h.75V6.85h-.75V5.53zM9.258 5.531h.75V6.85h-.75V5.53zM11.383 5.531h.75V6.85h-.75V5.53zM13.516 5.531h.75V6.85h-.75V5.53zM15.64 5.531h.75V6.85h-.75V5.53z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcOrganisations;
